// extracted by mini-css-extract-plugin
var _1 = "TemplatesSuggestions-module__animateUploadProgressBarWidth--U3AjL";
var _2 = "TemplatesSuggestions-module__animatedBackground--PG3R4";
var _3 = "TemplatesSuggestions-module__buttons--jRbjH";
var _4 = "TemplatesSuggestions-module__categoryButton--HPTdl";
var _5 = "TemplatesSuggestions-module__container--X_sPq";
var _6 = "TemplatesSuggestions-module__description--BlRwK";
var _7 = "TemplatesSuggestions-module__separator--gJuY4";
var _8 = "TemplatesSuggestions-module__separatorText--B8p9F";
var _9 = "TemplatesSuggestions-module__templates--WCpNb";
var _a = "TemplatesSuggestions-module__title--D5vWM";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "buttons", _4 as "categoryButton", _5 as "container", _6 as "description", _7 as "separator", _8 as "separatorText", _9 as "templates", _a as "title" }
